export class ExportRequest {
  public Format: string;
  public BeginYear: number;
  public BeginMonth: number;
  public EndYear: number;
  public EndMonth: number;
  public EndDate: Date;
  public WellIds: Array<number>;
  public IncludeWellIds?: boolean;
}
